import type { FaireProductEntity } from "../../entity_types/product";

export const p_bldn8hc8ry: FaireProductEntity = {
  token: "p_bldn8hc8ry",
  type: "product",
  name: "Thank You Stud Earrings Card",
  brandToken: "b_cllfpw8grf",
  brandName: "Tiny Gift Society",
  imageUrl:
    "https://cdn.faire.com/fastly/badc4e576b06ce89ab3c5dc1b9ff6db55ab62261b8b0356ac47610a6e01edfd2.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.73,
  description:
    "Your customers and clients will love this adorable little gift!\n\nStud earrings in a variety of styles and colors on a Thank You card.  An easy way to show your appreciation with a small, yet stunning gift.\n\nA great way for boutiques to give customer appreciation thank you gifts for women.\n\nRandomly selected, assorted styles and colors.\n\nGreat for:\n- Thank You Gifts\n- Customer Appreciation Gifts\n- Stud Earrings, Jewelry, Accessories\n- Table Fillers\n- Sub Boxes (Subscription Boxes)\n- Women Teens Girls",
  tags: [],
  msrpDollars: 3.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:25.246Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
